$(function(){
    $.fn.myFormText=function(options){
        var methods={
            remove:function(obj){
                obj.html("");
                obj.data("myFormText",null);  
            },
            update:function(obj,val){
                val=textToInt(val);
                var set= obj.data("myFormText");
                if(set.max!=-1){
                    val=Math.min(set.max,val);
                }
                if(set.min!=-1){
                    val=Math.max(set.min,val);
                }
                var obj_trigger=obj.find(">.myFormInputTrigger");
                
                if(obj_trigger.is("input")){
                    obj_trigger.val(numberFormat(val,0,0));
                }
                else{
                    obj_trigger.html(numberFormat(val,0,0));
                }
                var was_updated=0;
                if(set.val!=val){
                    set.val=val;
                    was_updated=1;
                }
                obj.data("myFormText", set);
                
                if(was_updated){
                    set.on_update(val,obj);
                    obj.trigger("myFormText",val);
                }
                
            },
        };
        function findNextVal(val,arr){
            var i,bum,next=false;
            for(i in arr){
                bum=arr[i];
                if(bum>val && (next===false || bum<next)){
                    next=bum;
                }
            }
            if(next===false){
                next=maxArr(arr);
            }
            return next;
        }
        function findPrevVal(val,arr){
            var i,bum,next=false;
            for(i in arr){
                bum=arr[i];
                if(bum<val && (next===false || bum>next)){
                    next=bum;
                }
            }
            if(next===false){
                next=minArr(arr);
            }
            return next;
        }
        function init(obj,settings){
            obj.append("<div class='minusText'></div><div class='plusText'></div>");
            var obj_trigger=obj.find(">.myFormInputTrigger");
            var val=-1;
            if(obj_trigger.is("input")){
                val=textToInt(obj_trigger.val());
            }
            else{
                val=textToInt(obj_trigger.html());
            }
            if(settings.val!=-1){
                val=settings.val;
            }
            else if(val=-1){
                val=settings.min;
            }
            settings.val=val;
            obj.data("myFormText", settings);
            methods.update(obj,val);
            obj.find(">.minusText").click(function(){
                _mySound.playSound("page_selector");
                var set= obj.data("myFormText"),val;
                if(set.val_arr.length>0){
                    val=findPrevVal(set.val,set.val_arr);
                }
                else{
                    val=set.val-1; 
                }
                methods.update(obj,val);
            }).end().find(">.plusText").click(function(){
                _mySound.playSound("page_selector");
                var set= obj.data("myFormText"),val;
                if(set.val_arr.length>0){
                    val=findNextVal(set.val,set.val_arr);
                }
                else{
                   val=set.val+1; 
                }
                
                methods.update(obj,val);
            });
            obj_trigger.on("change",function(){
                var th=$(this);
                if(th.is("input")){
                    methods.update(th.closest(".myFormInput"),th.val());
                }
            });
        }
        var last_this=$(this); 
        var arg =Array.prototype.slice.call(arguments,1);
        return $(this).each(function(key) {  
            var $this = $(this);
            if(methods[options]){  
                arg.unshift($this);
                return methods[options].apply($this,arg);
            }
            else if (typeof options === 'object' || !options){ 
                var data = $this.data("myFormText");  
                if(!data){    
                    $this.addClass("myFormText");
                    var settings = $.extend( {
                       val_arr:[],
                       val:-1,
                       max:-1, 
                       min:0,
                       on_update:function(val,obj){
                           
                       }
//                        repeat_last:0,//how many px show from previous page
                    }, options);
                    if(settings.val_arr.length){
                        settings.max=maxArr(settings.val_arr);
                        settings.min=minArr(settings.val_arr);
                    }
                    init($this,settings); 
                }                
                return;
            }
            else{
                $.error('myFormText: no method: '+ options);
            }
        });
    }; 
});